
import React, { Component } from 'react';
import Header from './components/Header'
import Footer from './components/Footer'
import Loader from './components/Loader'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      className: "load-background",
      loadTimer: 500
    }
    this.hideLoader = this.hideLoader.bind(this)
  }

  componentDidMount() {
    setTimeout(this.hideLoader, this.state.loadTimer)
    this.setState({
      loadTimer: 0
    })
  }

  hideLoader() {
    this.setState({
      className: "invisible"
    })
  }

  render() {

    return (
      <div>
        <Loader className={this.state.className} />
        <Header/>
        { this.props.children }
        <Footer />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/